import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';

interface ZapyIconProps {
  fontSize?: 'small' | 'medium' | 'large' | 'inherit' | number;
  sx?: SxProps<Theme>;
  color?: string;
}

const SIZE_MAP: Record<string, number> = {
  small: 20,
  medium: 24,
  large: 35,
  inherit: 24,
};

export function ZapyIcon({ fontSize = 'medium', sx, color }: ZapyIconProps) {
  const size = typeof fontSize === 'number' ? fontSize : SIZE_MAP[fontSize] ?? 24;

  return (
    <Box
      component="img"
      src="https://brand-cdn.zapyapi.com/logos/logo.png"
      alt="Zapy"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'inline-block',
        verticalAlign: 'middle',
        ...(color ? { filter: 'none' } : {}),
        ...((sx as Record<string, unknown>) ?? {}),
      }}
    />
  );
}
